import { isPayment } from '@debbie/common/dist/economy/helpers/vouchers.js';
import { VoucherTypeSetting } from '@debbie/common/dist/economy/vouchers/index.js';
import { CaseVoucherInterestSettings } from '@debbie/common/dist/economy/vouchers/setup.js';
import { Site } from '@debbie/common/dist/index.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
import { useCaseConditions } from '@debbie/cortex/dist/case-conditions/index.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { useLimitationDocuments } from '@debbie/cortex/dist/documents/index.js';
import { useEconomyPolicy } from '@debbie/cortex/dist/economy-policy/index.js';
import { useFixedDistributionsByCaseId } from '@debbie/cortex/dist/fixed-distributions/index.js';
import { useInterestCalulation } from '@debbie/cortex/dist/heavy-calculations/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import AssociationIcon from '../../Icons/AssociationIcon.js';
import { Money, Table, Tag } from '../../index.js';
import Billings from '../Billings.js';
import CaseVoucherInfoActions from './CaseVoucherInfoActions.js';
import CaseVoucherInfoDistributions from './CaseVoucherInfoDistributions.js';
import CaseVoucherInfoMeta from './CaseVoucherInfoMeta.js';
const CaseVoucherInfo = (props) => {
    const { caseVoucher, caseVouchers, singleCase } = props;
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    const documentsLoader = useLimitationDocuments(singleCase?.caseId);
    const documents = h.hasData(documentsLoader) ? documentsLoader.data : null;
    const site = useSelector((s) => s.site);
    const caseVouchers_ = useCaseVouchersByCase(singleCase?.caseId);
    const _caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const until = moment().format();
    const fixedDistributionsLoader = useFixedDistributionsByCaseId(singleCase?.caseId);
    const fixedDistributions = h.hasData(fixedDistributionsLoader)
        ? fixedDistributionsLoader.data
        : null;
    const conditionsLoader = useCaseConditions(singleCase?.caseId);
    const conditions = h.hasData(conditionsLoader) ? conditionsLoader.data : null;
    const interestLoader = useInterestCalulation(JSON.parse(JSON.stringify(_caseVouchers)), documents, useEconomyPolicy(singleCase), fixedDistributions, conditions, until, { appendHist: true });
    const caseVouchersWithHistory = h.hasData(interestLoader)
        ? interestLoader.data
        : null;
    const voucherWithInterestHistory = caseVouchersWithHistory &&
        caseVouchersWithHistory.find((v) => v.caseVoucherId === caseVoucher.caseVoucherId);
    return (React.createElement(React.Fragment, null,
        caseVoucher.associationId && (React.createElement(React.Fragment, null,
            React.createElement(AssociationIcon, { style: { margin: '0.2em 0 -0.2em' } }),
            ' ',
            lang.associateCases.caseVoucherIsAssociated)),
        React.createElement(CaseVoucherInfoMeta, { caseVoucher: caseVoucher, caseVouchers: caseVouchers, singleCase: singleCase }),
        React.createElement(Tags, null, caseVoucher.tags?.map((tag, key) => {
            return (React.createElement(Tag, { key: key }, lang.caseVoucherTags[tag.tag] || tag.tag));
        })),
        voucherWithInterestHistory &&
            voucherWithInterestHistory.setting &&
            CaseVoucherInterestSettings.includes(voucherWithInterestHistory.setting) &&
            voucherWithInterestHistory.interestHistory && (React.createElement(InterestHistory, null,
            React.createElement("h3", null, lang.economy.voucherInfoInterestHis),
            React.createElement(Table, { zebra: true },
                React.createElement("tr", null,
                    React.createElement("th", { style: { textAlign: 'left' } }, lang.economy.voucherInfoIfrom),
                    React.createElement("th", { style: { textAlign: 'left' } }, lang.economy.voucherInfoITo),
                    React.createElement("th", { style: { textAlign: 'left' } }, lang.economy.voucherInfoIInterval),
                    React.createElement("th", { style: { textAlign: 'right' } }, lang.economy.voucherInfoIRVA),
                    voucherWithInterestHistory.setting ===
                        VoucherTypeSetting.CompoundInterest && (React.createElement("th", { style: { textAlign: 'right' } }, lang.economy.voucherInfoICompoundedAmount)),
                    React.createElement("th", { style: { textAlign: 'right' } }, lang.economy.amount)),
                voucherWithInterestHistory.interestHistory &&
                    [...voucherWithInterestHistory.interestHistory]
                        // Reapplied rows carry nominal dates but are appended at
                        // the default, so sort for display. Dates are calendar
                        // days at UTC midnight.
                        .sort((a, b) => a.from - b.from || a.to - b.to)
                        .map((item, key) => (React.createElement("tr", { key: key },
                        React.createElement("td", null, moment.utc(item.from).format(THEME.DATE_FORMAT_SHORT)),
                        React.createElement("td", null, moment.utc(item.to).format(THEME.DATE_FORMAT_SHORT)),
                        React.createElement("td", null,
                            moment
                                .utc(item.to)
                                .diff(moment.utc(item.from), 'days'),
                            ' ',
                            lang.economy.voucherInfoIDays,
                            item.reapplied && (React.createElement(ReappliedBadge, null, lang.economy.voucherInfoIReapplied))),
                        React.createElement("td", { style: { textAlign: 'right' } },
                            React.createElement("small", null,
                                "(",
                                `${parseFloat((item.interest * 100).toFixed(3))}`.replace('.', ','),
                                ' ',
                                "%)"),
                            ' ',
                            React.createElement(Money, { amount: item.referenceVoucherBalance })),
                        voucherWithInterestHistory.setting ===
                            VoucherTypeSetting.CompoundInterest && (React.createElement("td", { style: { textAlign: 'right' } },
                            React.createElement(Money, { amount: item.capitalizedInterestBalance || 0 }))),
                        React.createElement("td", { style: { textAlign: 'right' } },
                            React.createElement(Money, { amount: item.amount })))))))),
        voucherWithInterestHistory && _caseVouchers && (React.createElement(CaseVoucherInfoDistributions, { voucher: voucherWithInterestHistory, caseVouchers: _caseVouchers, fixedDistributions: fixedDistributions, singleCase: singleCase })),
        isPayment(caseVoucher) && tenant?.type === TenantType.Agency && (React.createElement(BillingsSection, null,
            React.createElement("h3", null, lang.billing.appendix),
            React.createElement(Billings, { depositCaseVoucherId: caseVoucher.caseVoucherId }))),
        React.createElement("br", null),
        site === Site.Caseworker && React.createElement(CaseVoucherInfoActions, { ...props })));
};
export default CaseVoucherInfo;
const Tags = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 14px;
  padding: 6px 0;
`;
const InterestHistory = styled.div `
  margin-bottom: 20px;
`;
const ReappliedBadge = styled.small `
  display: inline-block;
  margin-left: 6px;
  padding: 0 5px;
  border-radius: 4px;
  background: #fff3e0;
  color: #b25e00;
`;
const BillingsSection = styled.div `
  margin-top: 10px;
`;
//# sourceMappingURL=CaseVoucherInfo.js.map